<template>
  <div class="news">
    <div class="container">
      <h1>新闻资讯</h1>
      <p class="subtitle">最新行业动态和公司新闻</p>
      <div class="news-list">
        <div class="news-item">
          <div class="news-date">2025-10-22</div>
          <h3>权威认证，实力加冕！</h3>
          <p>近日，山东隆之智环保科技有限公司迎来发展历程中的重要里程碑！中华环保联合会秘书长吴克食先生携权威专家黄威、高红一行，共同莅临隆之智，就挥发性有机物（VOCs）泄漏检测与修复（LDAR）服务认证工作进行了全面、细致的现场审查与指导。</p>
          <router-link to="/news/1" class="read-more">阅读更多</router-link>
        </div>
        <div class="news-item">
          <div class="news-date">2025-10-20</div>
          <h3>隆之智LDAR平台荣获“淄博市优秀软件产品”！</h3>
          <p>近日，淄博市工业和信息化局发布《2025年淄博市优秀软件企业和软件产名单》，我司自主研发的“泄漏检测与修复（LDAR）管控平台”获评“淄博市优秀软件产品”！</p>
          <router-link to="/news/2" class="read-more">阅读更多</router-link>
        </div>
        <div class="news-item">
          <div class="news-date">2024-09-04</div>
          <h3>隆之智LDAR综合管平台服务--培训篇</h3>
          <p>隆之智向环保检测行业提供LDAR综合管理系统的共享服务及数据托管服务，并为共享合作方提供系统相关应用的培训服务。</p>
          <router-link to="/news/3" class="read-more">阅读更多</router-link>
        </div>
        <div class="news-item">
          <div class="news-date">2024-07-26</div>
          <h3>隆之智董事长田源当选中华环保联合会理事</h3>
          <p>7月25日，中华环保联合会第四届会员代表大会在京隆重召开。会议选举产生了中华环保联合会第四届理事会，第二届监事会。山东隆之智环保科技有限公司董事长田源当选中华环保联合会第四届理事会理事。</p>
          <router-link to="/news/4" class="read-more">阅读更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNews'
}
</script>

<style scoped>
.news {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
  text-align: center;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 50px;
}

@media screen and (max-width: 768px) {
  .news {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .news {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.news-item {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.news-item:hover {
  transform: translateY(-5px);
  background-color: #e6f3ee;
}

.news-date {
  display: inline-block;
  background-color: #42b983;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 15px;
}

.news-item h3 {
  font-size: 22px;
  margin-bottom: 15px;
  color: #333;
}

.news-item p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .news-item {
    padding: 25px;
  }

  .news-item h3 {
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .news-item {
    padding: 20px;
  }

  .news-date {
    padding: 4px 8px;
    font-size: 12px;
  }

  .news-item h3 {
    font-size: 18px;
  }

  .news-item p {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .read-more {
    font-size: 14px;
  }
}

.read-more {
  display: inline-block;
  color: #42b983;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;
}

.read-more:hover {
  color: #3aa876;
}
</style>